export const useFormat = () => {
  const formatCost = (cost?: number) => {
    return cost ? `$${cost}` : "";
  };

  return {
    formatCost,
  };
};
